import { isObject, type SimpleTradeSiteListItem, useApiTradeV1TradeSitesList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SimpleTradeSiteListItem>, 'options' | 'defaultValue'> & {
  tradeCompanies?: number[];
  defaultValue?: SimpleTradeSiteListItem['id'];
};

export const TradeCompanySiteAutocomplete = ({ tradeCompanies, required = false, defaultValue, ...rest }: Props) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');
  const isEnabled = Boolean(tradeCompanies?.length);

  const { data, isLoading } = useApiTradeV1TradeSitesList(
    {
      search: query,
      trade_companies: tradeCompanies,
    },
    {
      query: {
        enabled: isEnabled,
      },
    }
  );

  return (
    <AutocompleteField<SimpleTradeSiteListItem>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.full_address) {
          return option.full_address;
        }
        return '';
      }}
      disabled={!isEnabled}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      required={required}
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...rest}
    />
  );
};
